<template>
  <div>
    <HelpTip v-bind="labelInfo"></HelpTip>
    <van-field
      class="switch work-temp-form-item"
      :name="id"
      :rules="[{ required, message: languages.smartOrderPleaseChoose + label }]"
      :value="formData[id]"
      readonly
      clickable
    >
      <template #input>
        <van-switch
          v-model="formData[id]"
          size="35px"
          active-value="true"
          inactive-value="false"
        />
      </template>
    </van-field>
  </div>
</template>

<script>
import workTemp from '@mixins/officialSupport/workTemp';
export default {
  name: 'TempSwitch',
  mixins: [workTemp],
  created() {
    this.formData[this.id] = 'false';
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
</style>
